import * as React from "react";
import * as main from "../../main.module.scss";
import * as help from "./style.module.scss";
export const Help = () => {
  return (
    <section className={help.help}>
      <div className="container">
        <div className={help.inner}>
          <h2 className={main.title}>Курс поможет вашему ребёнку:</h2>
          <ul className={help.main}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/kurs-icon-01.png" alt=""/>
              <p><strong>Самостоятельно осмысленно читать</strong> —  ребёнок научится чтению простых текстов с пониманием анализом прочитанного</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/kurs-icon-02.png" alt=""/>
              <p><strong>Запоминать информацию</strong> — ребёнок не будет прибегать к зубрёжке и безуспешному повторению прочитанного текста </p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/kurs-icon-03.png" alt=""/>
              <p><strong>Быстро обрабатывать информацию</strong>, запоминать новое, пересказывать тексты разного уровня сложности</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/kurs-icon-04.png" alt=""/>
              <p><strong>Сократить время выполнения домашних заданий —</strong> ребёнок сможет больше отдыхать или уделить внимание увлечениям</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/kurs-icon-05.png" alt=""/>
              <p><strong>Стать интеллектуально выносливым —</strong> ребёнок сможет концентрироваться на учебных задачах и не успускать важное</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya_nachalo/kurs-icon-06.png" alt=""/>
              <p><strong>Полюбить школу и обучение —</strong> ребёнок будет чувствовать, что учёба даётся ему легко и он успешен</p>
            </li>
          </ul>
          <h2 className={main.title}>А также:</h2>
          <ul className={help.more}>
            <li><p><strong>Освоить навык устного счёта</strong> и довести его до автоматизма</p></li>
            <li><p><strong>Развить образное мышление</strong>, которое влияет на творческие способности и воображение</p></li>
            <li><p><strong>Обогатить словарный запас</strong> и поставить красивую и структурированную речь</p></li>
            <li><p><strong>Научит ребёнка классифицировать и обобщать</strong>, что поможет ему логически мыслить</p></li>
          </ul>
          <a href={"#widget"} className={main.btn}>Купить курс</a>
        </div>
      </div>
    </section>
  );
};
